import React, { useState } from 'react';
import './FreeAssessment.css';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';

const FreeAssessment = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    course: 'Noorani Qaida',
    country: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.lastName || !formData.course || !formData.country || formData.country === 'Country' || !formData.phone || !formData.message) {
      Swal.fire({
        title: 'All Fields Required',
        text: 'Please fill in all fields including Country and Message.',
        icon: 'warning',
        confirmButtonColor: '#5c9456'
      });
      return;
    }
    try {
      await submitForm('Free Assessment Form', formData);
      Swal.fire({
        title: 'Success!',
        text: `Thank you, ${formData.firstName}! Your free assessment request has been submitted.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setFormData({
        firstName: '',
        lastName: '',
        course: 'Noorani Qaida',
        country: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  return (
    <section className="free-assessment" id="free-trial">
      <div className="free-assessment__container">
        {/* Left Column: Info Text */}
        <div className="free-assessment__info">
          <h4 className="free-assessment__subtitle">
            <svg aria-hidden="true" className="free-assessment__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>Apply For Free Registration</span>
          </h4>

          <h2 className="free-assessment__title">
            Not Sure Where to Start? We'll Help You Find the Right Course
          </h2>

          <p className="free-assessment__description">
            We can do this together with you at no cost. The tutor will work with you to assess the Quran reading and recommend the best course that truly fits rather than just the most marketable one.
          </p>

          <ul className="free-assessment__benefits">
            <li className="free-assessment__benefit-item">
              <svg className="free-assessment__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
              <span>Experienced Tutors</span>
            </li>
            <li className="free-assessment__benefit-item">
              <svg className="free-assessment__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
              <span>Flexible Hours</span>
            </li>
          </ul>

          <div className="free-assessment__contacts">
            <a href="tel:+17164577657" className="free-assessment__contact-item">
              <div className="free-assessment__contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="free-assessment__contact-svg">
                  <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                </svg>
              </div>
              <div className="free-assessment__contact-text">
                <span className="free-assessment__contact-label">Call Us Anytime</span>
                <span className="free-assessment__contact-value">(716) 457-7657</span>
              </div>
            </a>

            <a href="mailto:info@alquranlesson.com" className="free-assessment__contact-item">
              <div className="free-assessment__contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="free-assessment__contact-svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </div>
              <div className="free-assessment__contact-text">
                <span className="free-assessment__contact-label">Email Us Anytime</span>
                <span className="free-assessment__contact-value">info@alquranlesson.com</span>
              </div>
            </a>
          </div>
        </div>

        {/* Right Column: Registration Form */}
        <div
          className="free-assessment__form-container"
          style={{
            '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
          }}
        >
          <form className="free-assessment__form" onSubmit={handleSubmit}>
            <div className="free-assessment__form-row">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="free-assessment__input"
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="free-assessment__input"
              />
            </div>

            <div className="free-assessment__form-row free-assessment__form-row--full">
              <select
                name="course"
                value={formData.course}
                onChange={handleChange}
                required
                className="free-assessment__select"
              >
                <option value="" disabled>Select Course</option>
                <option value="Noorani Qaida">Noorani Qaida</option>
                <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
                <option value="Quran Reading Classes">Quran Reading Classes</option>
                <option value="Quran Memorization Classes">Quran Memorization Classes</option>
                <option value="Quran Translation Classes">Quran Translation Classes</option>
              </select>
            </div>

            <div className="free-assessment__form-row">
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                required
                className="free-assessment__select"
              >
                <option value="" disabled>Select Country</option>
                <option value="USA">USA</option>
                <option value="UK">UK</option>
                <option value="CA">CA</option>
                <option value="Australia">Australia</option>
                <option value="Other">Other</option>
              </select>
              <input
                type="tel"
                name="phone"
                placeholder="Phone No"
                value={formData.phone}
                onChange={handleChange}
                required
                className="free-assessment__input"
              />
            </div>

            <div className="free-assessment__form-row free-assessment__form-row--full">
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                required
                className="free-assessment__textarea"
              />
            </div>

            <button type="submit" className="free-assessment__submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default FreeAssessment;

